<template>
  <custom-tag
    v-bind="$attrs"
    :value="value"
    :disabled="disabled"
    :variant="variant"
    :remove-option="removeOption"
    :classes="classes"
    :tooltip-text="tooltipText"
    :hide-tooltip="hideTooltip"
    :click-enabled="clickEnabled"
    :double-click-enabled="doubleClickEnabled"
    :is-update-in-process="planetStore.isUpdateInProcess"
    @remove="emit('remove')"
    @custom-tag-click="tagClicked()"
    @custom-tag-double-click="emit('custom-tag-double-click')"
  >
  </custom-tag>
</template>

<script setup lang="ts">
import { useTagsStore } from '@/store/TagsStore';
import { usePlanetStore } from '@/store/PlanetStore';
import CustomTag from 'ui-component-library/rbz/components/CustomTag.vue';
import { TagVariant } from '@/types';

interface RbzCustomTagProps {
  disabled?: boolean;
  value: string;
  variant?: TagVariant;
  removeOption?: boolean;
  classes?: string;
  tooltipText?: string;
  hideTooltip?: boolean;
  clickEnabled?: boolean;
  doubleClickEnabled?: boolean;
}

const props = withDefaults(defineProps<RbzCustomTagProps>(), {
  disabled: false,
  variant: 'fill',
  removeOption: false,
  hideTooltip: false,
  clickEnabled: true,
});

interface RbzCustomTagEmits {
  (e: 'remove'): void;

  (e: 'custom-tag-click'): void;

  (e: 'custom-tag-double-click'): void;
}

const emit = defineEmits<RbzCustomTagEmits>();

const tagsStore = useTagsStore();
const planetStore = usePlanetStore();

const tagClicked = () => {
  tagsStore.selectedTag = props.value;
  emit('custom-tag-click');
};
</script>
